import { Form, Input } from 'antd';
import { FormInstance } from 'antd/es/form/Form';
import FormItem from 'antd/es/form/FormItem';
import { useEffect } from 'react';
import {
  COMMERCIAL_TERMS,
  GAMBLING_DISCOUNT_TYPE,
} from '../constants/provider-form.types';
import { ProviderTypeSelectorComponent } from '../shared/provider-type-selector.component';
import { LineGroupIdInputComponent } from '../shared/line-group-id-input.component';

export function ProviderForm({
  form,
  data,
}: {
  form: FormInstance;
  data?: {
    address: string | null;
    addressComment: string | null;
    idNumber: string;
    lineGroupId: string;
    name: string;
    nickname: string;
    taxId: string | null;
    businessInfo: {
      chargeSlottingFee: boolean;
      commercialTerms: COMMERCIAL_TERMS | null;
      commission: number | null;
      gamblingRules: Array<{
        itemSoldQuantityGuarantee: number;
        discountType: GAMBLING_DISCOUNT_TYPE;
        discountAmount: number;
      }> | null;
    } | null;
    paymentInfo: {
      account: string | null;
      accountName: string | null;
      bankName: string | null;
      bankBranchName: string | null;
      receiptType: string | null;
      shouldInvoice: boolean;
    } | null;
  };
}) {
  useEffect(() => {
    form.resetFields();
  }, [form]);

  return (
    <Form form={form} initialValues={data} autoComplete="off">
      <FormItem
        name="idNumber"
        label="編號"
        rules={[
          {
            required: true,
            message: '請輸入編號',
          },
        ]}
      >
        <Input />
      </FormItem>
      <FormItem
        name="name"
        label="名稱"
        rules={[
          {
            required: true,
            message: '請輸入名稱',
          },
        ]}
      >
        <Input />
      </FormItem>
      <FormItem
        name="nickname"
        label="簡稱"
        rules={[
          {
            required: true,
            message: '請輸入簡稱',
          },
        ]}
      >
        <Input />
      </FormItem>
      <ProviderTypeSelectorComponent />
      <LineGroupIdInputComponent />
    </Form>
  );
}
